import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { RadioButton } from "primereact/radiobutton";
import SessionsCarousel from "../../../../../components/sharedComponents/SessionsCarousel";
import { useState, useRef, useEffect } from "react";
import ReactPlayer from "react-player";
import { TabPanel, TabView } from "primereact/tabview";
import FilterOptions from "../FilterOptions";
import PresentationBuilder from "../../../../../components/PresentationBulder/PresentationBuilder";

const sessions = [
  { id: 1, name: "Wendoline S", title: "Cooking In Your Home" },
  { id: 2, name: "Alex Q", title: "Cooking In Your Home" },
  { id: 3, name: "Ira D", title: "Cooking In Your Home" },
  { id: 4, name: "Jesseca A", title: "Cooking In Your Home" },
  { id: 5, name: "Jeff B", title: "Cooking In Your Home" },
  { id: 6, name: "Kimberlee C", title: "Cooking In Your Home" },
  { id: 7, name: "Bobby S", title: "Cooking In Your Home" },
  { id: 8, name: "Bobby S", title: "Cooking In Your Home" },
  { id: 9, name: "Bobby S", title: "Cooking In Your Home" },
  { id: 10, name: "Bobby S", title: "Cooking In Your Home" },
];

const SavedItemsTab = () => {
  const [selectedSession, setSelectedSession] = useState(0);
  const filterButtonRef = useRef(null);
  const filterDropdownRef = useRef(null);

  const [isFilterOptionVisible, setIsFilterOptionVisible] = useState(false);
  const [tempFilterOptions, setTempFilterOptions] = useState({
    participant: "All",
    tag: "",
    note: "",
    viewer: "Select",
    segment: "",
  });

  const [isTagsEdit, setIsTagsEdit] = useState(false);
  const [isNotesEdit, setIsNotesEdit] = useState(false);
  const [isCreatedByEdit, setIsCreatedByEdit] = useState(false);
  const [presentations, setPresentations] = useState([
    {
      id: 1,
      name: "PRESENTATION 1",
      slides: [
        { id: 1, slideName: "Good Not Down 1", slideVideos: [...sessions] },
        { id: 2, slideName: "Like It", slideVideos: [...sessions] },
        { id: 3, slideName: "Dislike", slideVideos: [...sessions] },
      ],
      isPresentationMinimise: false,
    },
  ]);

  // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       filterDropdownRef.current &&
  //       !filterDropdownRef.current.contains(event.target) &&
  //       filterButtonRef.current &&
  //       !filterButtonRef.current.contains(event.target)
  //     ) {
  //       setIsFilterOptionVisible(false);
  //     }
  //   };

  //   if (isFilterOptionVisible) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [isFilterOptionVisible]);

  const addSlide = (presentationId) => {
    setPresentations((prev) =>
      prev.map((p) =>
        p.id === presentationId
          ? {
              ...p,
              slides: [
                ...p.slides,
                {
                  id: p.slides.length + 1,
                  slideName: "New Slide",
                  slideVideos: [],
                  isPresentationMinimise: false,
                },
              ],
            }
          : p,
      ),
    );
  };

  const handlePresentationMinimize = (pIndex, isMinimized) => {
    setPresentations((prev) =>
      prev.map((p, index) =>
        index === pIndex ? { ...p, isPresentationMinimise: isMinimized } : p,
      ),
    );
  };

  const addPresentation = () => {
    setPresentations((prev) => [
      ...prev,
      {
        id: prev.length + 1,
        name: `PRESENTATION ${prev.length + 1}`,
        slides: [],
      },
    ]);
  };

  const deletePresentation = (index) => {
    setPresentations((prev) => prev.filter((_, i) => i !== index));
  };

  const deleteSlide = (presentationId, slideId) => {
    setPresentations((prev) =>
      prev.map((p, i) =>
        i === presentationId
          ? { ...p, slides: p.slides.filter((slide, sId) => sId !== slideId) }
          : p,
      ),
    );
  };

  const toggleFilterDropdown = () => {
    setIsFilterOptionVisible(!isFilterOptionVisible);
  };

  return (
    <div className="py-2 px-4 text-start">
      <div className="d-flex align-items-center my-3">
        <div className="me-2">Show:</div>
        <RadioButton
          inputId="all_save_items"
          name="allSavedItem"
          value="allSavedItem"
          onChange={(e) => {
            console.log("e.target.value", e.target.value);
          }}
          checked={true}
        />
        <label htmlFor="next_time_product_used" className="ms-2 fs-14">
          All Saved Items
        </label>
      </div>
      <Divider />
      <div className="d-flex justify-content-end my-3">
        <div className="filter-btn-wrapper rounded position-relative">
          <Button ref={filterButtonRef} link onClick={toggleFilterDropdown}>
            <i className="pi pi-align-center pe-2 text-muted" />
            Filter
          </Button>
          <div ref={filterDropdownRef}>
            <FilterOptions
              tempFilterOptions={tempFilterOptions}
              setTempFilterOptions={setTempFilterOptions}
              isFilterOptionVisible={isFilterOptionVisible}
              setIsFilterOptionVisible={setIsFilterOptionVisible}
            />
          </div>
        </div>
      </div>
      <Divider />

      <section className="clips my-3">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="text_dark fw-600 mb-4">Saved Items</h5>
          <div className="text-muted fs-14">
            Right-click or drag & drop video clips, images into the appropriate
            slide
          </div>
        </div>
        <SessionsCarousel
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
          sessionsData={sessions}
        />
      </section>

      <div className="row m-0">
        <div className="col-md-6">
          <div className="position-relative">
            <ReactPlayer
              className="w-100"
              style={{ height: "500px" }}
              src="https://www.youtube.com/watch?v=LXb3EKWsInQ"
              controls
            />

            <div className="d-flex align-items-center justify-content-between my-2">
              <h5 className="text_dark fw-600 mb-0">Participant Id: 9926</h5>
              <div className="group-btns d-flex align-items-center">
                <i className="pi pi-download"></i>
                <Button className="px-1 py-0" label="Download Clip" link />
                <span className="text-muted mx-3">|</span>
                <i className="pi pi-video"></i>
                <Button className="px-1 py-0" label="Watch Full Video" link />
              </div>
            </div>

            <Divider />

            <div className="my-3">
              <div className="d-flex align-items-center mb-2">
                <div className="d-flex align-items-center">
                  <i className="pi pi-tags" />
                  <div className="fw-bold ms-2">Tags:</div>
                  <div className="ms-2">
                    {isTagsEdit ? (
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={tempFilterOptions.tag}
                          onChange={(e) =>
                            setTempFilterOptions((prev) => ({
                              ...prev,
                              tag: e.target.value,
                            }))
                          }
                        />
                        <Button
                          icon="pi pi-check-circle"
                          className="p-button-text p-button ms-2 p-0"
                        />
                        <Button
                          icon="pi pi-times-circle"
                          className="p-button-text p-button p-0"
                          onClick={() => setIsTagsEdit(false)}
                        />
                      </div>
                    ) : (
                      <span>
                        Febreze, fabric, refresher, Febreze, Fabric, Refresher
                      </span>
                    )}
                  </div>
                </div>
                <div className="edit-icon ms-auto">
                  <Button
                    icon="pi pi-pencil"
                    className="p-button-text p-button-sm"
                    onClick={() => setIsTagsEdit(true)}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <div className="d-flex align-items-center">
                  <i className="pi pi-copy" />
                  <div className="fw-bold ms-2">Notes:</div>
                  <div className="ms-2">
                    {isNotesEdit ? (
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={tempFilterOptions.note}
                          onChange={(e) =>
                            setTempFilterOptions((prev) => ({
                              ...prev,
                              note: e.target.value,
                            }))
                          }
                        />
                        <Button
                          icon="pi pi-check-circle"
                          className="p-button-text p-button ms-2 p-0"
                        />
                        <Button
                          icon="pi pi-times-circle"
                          className="p-button-text p-button p-0"
                          onClick={() => setIsNotesEdit(false)}
                        />
                      </div>
                    ) : (
                      <span>Febreze, Fabric, Refresher</span>
                    )}
                  </div>
                </div>
                <div className="edit-icon ms-auto">
                  <Button
                    icon="pi pi-pencil"
                    className="p-button-text p-button-sm"
                    onClick={() => setIsNotesEdit(true)}
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mb-2">
                <div className="d-flex align-items-center">
                  <i className="pi pi-user" />
                  <div className="fw-bold ms-2">Created By:</div>
                  <div className="ms-2">
                    {isCreatedByEdit ? (
                      <div className="d-flex align-items-center">
                        <select
                          className="form-control form-control-sm"
                          value={tempFilterOptions.viewer}
                          onChange={(e) =>
                            setTempFilterOptions((prev) => ({
                              ...prev,
                              viewer: e.target.value,
                            }))
                          }
                        >
                          <option value="Select">Select</option>
                          <option value="Dev">Dev</option>
                          <option value="Admin">Admin</option>
                          <option value="User">User</option>
                        </select>
                        <Button
                          icon="pi pi-check-circle"
                          className="p-button-text p-button ms-2 p-0"
                        />
                        <Button
                          icon="pi pi-times-circle"
                          className="p-button-text p-button p-0"
                          onClick={() => setIsCreatedByEdit(false)}
                        />
                      </div>
                    ) : (
                      <span>Dev</span>
                    )}
                  </div>
                </div>
                <div className="edit-icon ms-auto">
                  <Button
                    icon="pi pi-pencil"
                    className="p-button-text p-button-sm"
                    onClick={() => setIsCreatedByEdit(true)}
                  />
                </div>
              </div>
            </div>

            <Divider />

            <div className="my-2">
              <h5 className="text_dark fw-600">Transcript</h5>
              <p>
                Okay. So the first question is, what type of cleaning tools? Do
                you currently use to wash your dishes in your sink? So I'm
                really embarrassed to admit that sponges are kind of the same to
                me. They get smelly, they get kind of stinky, you have to throw
                them away.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <PresentationBuilder
            presentations={presentations}
            setPresentations={setPresentations}
            addPresentation={addPresentation}
            addSlide={addSlide}
            deletePresentation={deletePresentation}
            deleteSlide={deleteSlide}
            handlePresentationMinimize={handlePresentationMinimize}
          />
        </div>
      </div>
    </div>
  );
};

export default SavedItemsTab;
